import React, { useState, useEffect } from 'react';
import { Container, Row, Card, CardBody, Col } from 'reactstrap';
import { useParams, useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { partial } from '../../util/translation/translation';
import LotteryPrizeForm from './components/LotteryPrizeForm';
import Loading from '../../shared/components/custom/Loading';
import Api from '../../util/api';

const LotteryPrizeFormPage = () => {
  const { lotteryPrizeID } = useParams();
  const history = useHistory();
  const [prize, setPrize] = useState(null);
  const [loading, setLoading] = useState(false);
  const s = partial('shared');
  const p = partial('lotteries');
  const getPrize = async () => {
    setLoading(true);
    try {
      const prizeData = await Api.lottery.prizes.getPrizeById(lotteryPrizeID);
      setPrize(prizeData);
      setLoading(false);
    } catch (err) {
      toast.error(JSON.stringify(err));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (lotteryPrizeID) {
      getPrize();
    }
  }, [lotteryPrizeID]);

  const onPrizeSubmit = async (values) => {
    const payload = {
      title: values.title,
      description: values.description,
      image: values.headingImage.croppedBase64 || values.headingImage.preview,
    };
    setLoading(true);
    try {
      if (lotteryPrizeID) {
        await Api.lottery.prizes.updatePrize(lotteryPrizeID, payload);
      } else {
        await Api.lottery.prizes.createPrize(payload);
      }
    } catch (err) {
      toast.error(err || s('somethingWentWrong'));
    } finally {
      setLoading(false);
      history.replace('/lottery?tab=2');
    }
  };

  return (
    <Container>
      <Loading loading={loading} />
      <Row>
        <Col>
          <h3 className="page-title">
            {lotteryPrizeID ? `${s('edit')}` : `${s('create')}`}{' '}
            {p('lotteryPrize')}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <LotteryPrizeForm
                onSubmit={onPrizeSubmit}
                prizeId={lotteryPrizeID}
                lotteryPrize={prize}
                type={lotteryPrizeID ? 'edit' : 'create'}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LotteryPrizeFormPage;
